'use strict';

$(document).ready(function () {
    $('.accordion-heading').on('click', function(){
        var accordionID = $(this).attr('id');
        var selector = "#"+ accordionID+'-img';
        $('.image-container .img-responsive').removeClass('show');
        $('.image-container').find(selector).addClass('show');
    });


    $('body').on('click', '.blog-content .info-icon', function () {
        $('.blog-tool-tip').removeClass('active');
        $(this).closest('li').find('.blog-tool-tip').addClass('active');
    });

    $('body').on('click', '.close-info-icon', function () {
        $(this).closest('li').find('.blog-tool-tip').removeClass('active');
    });

    $('body').click(function (e) {
        if (!$(e.target).closest('.info-icon').length) {
            $('.blog-tool-tip').removeClass('active');
        }
    });
});
